<template>
  <div>
    <el-row>
      <div class="model-header">
        <h2>Cập nhật câu hỏi<!-- : Khóa: {{ configData.course.name }} --></h2>
        <el-button @click="backModel" size="small" class="btn-back">
          Trờ về <!-- : {{ configData.course.name }} -->
        </el-button>
      </div>
    </el-row>
    <el-row>
      <div class="model-content">
        <el-col :span="20">
          <el-form label-position="top" :rules="rules" :model="modelData" ref="createModel" @submit.native.prevent>
            <el-form-item prop="text" label="Nội dung câu hỏi" class="form-item">
<!--               <tinymce
                id="d1"
                v-model="modelData.text"
                :toolbar1="tinymce.toolbar1"
                :other_options="{ height: '200px', images_upload_handler: handleImageAdded , language_url: '/static/plugins/tinymce/vi_VN.js' }"></tinymce> -->
              <el-input v-model="modelData.text" type="textarea" :rows="3" class="input-seach"></el-input>
            </el-form-item>
            <el-form-item class="form-item">
              <el-row :gutter="20">
                <div v-for="(option, index) in modelData.options" :key="option.id">
                  <el-col :span="12">
                    <el-row :gutter="10">
                      <el-col :span="21">
                        <el-form-item :label="'Câu trả lời ' + (index + 1)" class="form-item">
                          <el-input v-model="option.text" type="textarea" :rows="2" class="input-seach"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="3">
                        <el-form-item label="Đáp án" class="form-item">
                          <el-radio v-model="modelData.radio" :label="option.id">{{ (index + 1) }}</el-radio>
                          <!-- <el-switch
                            active-color="#13ce66"
                            inactive-color="#7f8c8d"
                            v-model="option.is_answer">
                          </el-switch> -->
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </el-col>
                </div>
              </el-row>
            </el-form-item>
            <el-form-item>
              <el-button
                :disable="!canSubmit"
                :loading="!canSubmit"
                type="warning"
                size="small"
                @click="submitForm('createModel')">Cập nhật</el-button>
              <el-button
                size="small"
                class="btn-back"
                @click="backModel">Trở về
              </el-button>
            </el-form-item>
          </el-form>
        </el-col>
      </div>
    </el-row>
  </div>
</template>

<script>
import axios from 'axios'
import { head } from 'lodash'
import { mapActions } from 'vuex'
import tinymce from 'vue-tinymce-editor'
export default {
  name: 'QuestionCreate',
  metaInfo () {
    return {
      title: 'Câu hỏi | Thêm'
    }
  },
  components: {
    tinymce
  },
  data () {
    return {
      canSubmit: true,
      modelData: {
        text: '',
        lesson_id: '',
        type_question: 1,
        options: [
          {
            id: 1,
            text: '',
            is_answer: false
          },
          {
            id: 2,
            text: '',
            is_answer: false
          },
          {
            id: 3,
            text: '',
            is_answer: false
          },
          {
            id: 4,
            text: '',
            is_answer: false
          }
        ],
        status: true
      },

      configData: {
        course: {
          id: 0,
          name: 'Tên khóa này'
        },
        chapter: {
          id: 0,
          name: 'Tên chương này'
        },
        lesson: {
          id: 0,
          name: 'Tên bài học này'
        }
      },
      tinymce: {
        toolbar1: 'undo redo formatselect fontsizeselect | bold italic strikethrough forecolor backcolor | link media | alignleft aligncenter alignright alignjustify | numlist bullist outdent indent'
      },
      rules: {
        text: [
          { required: true, message: 'Vui lòng nhập nội dung câu hỏi' }
        ]
      }
    }
  },
  mounted () {
    this.configDataAndBreadcrumb()
    this.fetchModel()
  },
  methods: {
    handleImageAdded: async function (file, success, failure) {
      let formData = new FormData()
      formData.append('file', file.blob())
      let response = await axios.post('questions/upload', formData)
      if (response.code === 1) {
        success(response.data.path)
      } else {
        return false
      }
    },
    // Lấy action từ Vuex
    ...mapActions(['setBreadcrumb']),
    // Cấu hình dữ liệu về khóa học, bài, cấu hình Breadcrumb
    configDataAndBreadcrumb () {
      this.modelData.course_id = this.$route.params.course_id
      this.modelData.chapter_id = this.$route.params.chapter_id
      this.modelData.test_kit_id = this.$route.params.test_kit_id
      this.modelData.question_id = this.$route.params.question_id
      this.fetchCourse()
    },
    fetchCourse () {
      axios.get('courses/' + this.$route.params.course_id).then(response => {
        switch (response.code) {
          case 200:
            this.canSubmit = true
            this.configData.course = response.data
            this.fetchChapter()
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    fetchChapter () {
      axios.get('chapters/' + this.$route.params.chapter_id).then(response => {
        switch (response.code) {
          case 200:
            this.canSubmit = true
            this.configData.chapter = response.data
            this.fetchLesson()
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },

    fetchLesson () {
      axios.get('test-kits/' + this.$route.params.test_kit_id).then(response => {
        switch (response.code) {
          case 200:
            this.canSubmit = true
            this.configData.testkit = response.data
            this.configBreadcrumb()
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    configBreadcrumb () {
      let breadcrumb = [
        { name: 'home-index', text: 'Trang chủ' },
        { name: 'courses-index', text: 'Khóa học' },
        { name: 'courses-show', course_id: this.$route.params.course_id, text: this.configData.course.name },
        { name: 'chapters-show', course_id: this.$route.params.course_id, chapter_id: this.$route.params.chapter_id, text: this.configData.chapter.name },
        { name: 'test-kits-show', course_id: this.$route.params.course_id, chapter_id: this.$route.params.chapter_id, test_kit_id: this.$route.params.test_kit_id, text: this.configData.testkit.name },
        { name: 'test-kits-sho1w', text: 'Cập nhật câu hỏi' }
      ]
      this.setBreadcrumb(breadcrumb)
    },
    // Nút back lại trang Index
    backModel () {
      this.$router.push({name: 'test-kits-show', params: {course_id: this.$route.params.course_id, chapter_id: this.$route.params.chapter_id, test_kit_id: this.$route.params.test_kit_id}})
      // this.$router.push({name: 'lessons-show', params: {course_id: this.$route.params.course_id, chapter_id: this.$route.params.chapter_id}})
    },
    // Tải dữ liệu Model xuống
    fetchModel () {
      this.canSubmit = false
      axios.get('questions/' + this.$route.params.question_id, {params: {include: 'options'}}).then(response => {
        switch (response.code) {
          case 200:
            this.canSubmit = true
            this.modelData = response.data
            this.modelData.options = response.data.options.data
            for (let i = 0; i < this.modelData.options.length; i++) {
              if (this.modelData.options[i].is_answer === true) {
                this.modelData.radio = this.modelData.options[i].id
              }
            }
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    // Lưu dữ liệu
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.storeModel()
        } else {
          this.$notify({
            title: 'Lỗi dữ liệu nhập',
            message: 'Vui lòng kiểm tra lại thông tin',
            type: 'warning'
          })
          return false
        }
      })
    },
    storeModel () {
      this.canSubmit = false
      if (this.configData.testkit.type_question === 2) {
        delete this.modelData['options']
      }
      axios.put('questions/' + this.$route.params.question_id, this.modelData).then(response => {
        this.canSubmit = true
        switch (response.code) {
          case 200:
            this.$notify({
              title: 'Thành công',
              message: 'Cập nhật thành công',
              type: 'success'
            })
            // this.$router.push({name: 'test-kits-show', params: {course_id: this.$route.params.course_id, chapter_id: this.$route.params.chapter_id, test_kit_id: this.$route.params.test_kit_id}})
            // this.$router.push({name: 'lessons-show', params: {course_id: this.$route.params.course_id, chapter_id: this.$route.params.chapter_id}})
            break
          case 422:
            let er = response.data.errors
            let message = head(er[Object.keys(er)[0]])
            this.$notify({
              title: 'Có lỗi xảy ra',
              message: message,
              type: 'warning'
            })
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    }
  },
  watch: {
    'modelData.radio': function () {
      this.modelData.options[0].is_answer = false
      this.modelData.options[1].is_answer = false
      this.modelData.options[2].is_answer = false
      this.modelData.options[3].is_answer = false

      for (let i = 0; i < this.modelData.options.length; i++) {
        if (this.modelData.options[i].id === this.modelData.radio) {
          this.modelData.options[i].is_answer = true
        }
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style type="text/css" scoped>

</style>



// WEBPACK FOOTER //
// src/components/questions/Update.vue